import { useEffect, useState } from "react";
import { useT } from "@/lib/i18n";

const C = "https://commons.wikimedia.org/wiki/File:";
const BAZAAR = { en: "Bazaar, Moga city", pa: "ਬਾਜ਼ਾਰ, ਮੋਗਾ ਸ਼ਹਿਰ", hi: "बाज़ार, मोगा शहर" };
const SLIDES = [
  { src: "/moga/m0.jpg", place: BAZAAR, by: "MaplesyrupSushi", url: `${C}Bazaar_in_Moga_city,_Moga_tehsil,_Moga_district,_Punjab,_India,_9_April_2023_01.jpg` },
  { src: "/moga/m4.jpg", place: { en: "Gurdwara, Nihal Singh Wala", pa: "ਗੁਰਦੁਆਰਾ, ਨਿਹਾਲ ਸਿੰਘ ਵਾਲਾ", hi: "गुरुद्वारा, निहाल सिंह वाला" }, by: "Satdeep Gill", url: `${C}Gurdwara_at_Nihal_Singh_Wala.jpg` },
  { src: "/moga/m1.jpg", place: BAZAAR, by: "MaplesyrupSushi", url: `${C}Bazaar_in_Moga_city,_Moga_tehsil,_Moga_district,_Punjab,_India,_9_April_2023_02.jpg` },
  { src: "/moga/m8.jpg", place: { en: "Sunset over paddy fields, Punjab", pa: "ਝੋਨੇ ਦੇ ਖੇਤਾਂ ਉੱਤੇ ਸੂਰਜ ਡੁੱਬਣਾ, ਪੰਜਾਬ", hi: "धान के खेतों पर सूर्यास्त, पंजाब" }, by: "Jagseer S Sidhu", url: `${C}Sunset_on_a_Peddy_field_in_Punjab.jpg` },
  { src: "/moga/m2.jpg", place: BAZAAR, by: "MaplesyrupSushi", url: `${C}Bazaar_in_Moga_city,_Moga_tehsil,_Moga_district,_Punjab,_India,_9_April_2023_03.jpg` },
  { src: "/moga/m3.jpg", place: BAZAAR, by: "MaplesyrupSushi", url: `${C}Bazaar_in_Moga_city,_Moga_tehsil,_Moga_district,_Punjab,_India,_9_April_2023_04.jpg` },
];

export const MogaBanner = () => {
  const { lang } = useT();
  const [i, setI] = useState(0);
  useEffect(() => {
    const id = setInterval(() => { setI((n) => (n + 1) % SLIDES.length); }, 6000);
    return () => { clearInterval(id); };
  }, []);
  const s = SLIDES[i];
  return (
    <>
      <div className="absolute inset-0 z-0" data-testid="moga-banner">
        {SLIDES.map((sl, n) => (
          <img key={sl.src} src={sl.src.replace(".jpg", ".webp")} decoding="async" fetchPriority={n ? "low" : "high"} alt={sl.place.en} loading={n ? "lazy" : "eager"}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${n === i ? "opacity-100" : "opacity-0"}`} />
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-orange-950/85 via-orange-900/50 to-black/10" />
      </div>
      <div className="absolute bottom-2 right-3 z-10 flex items-center gap-3 text-[10px] text-white/80 lg:bottom-4 lg:right-6">
        <a href={s.url} target="_blank" rel="noreferrer" className="hover:text-white" data-testid="moga-banner-credit">
          {s.place[lang] || s.place.en} · Photo: {s.by}, CC BY-SA 4.0
        </a>
        <span className="flex gap-1">
          {SLIDES.map((_, n) => (
            <button key={n} onClick={() => setI(n)} aria-label={`Photo ${n + 1}`} data-testid={`moga-banner-dot-${n}`}
              className={`h-1.5 rounded-full bg-white transition-[width,opacity] ${n === i ? "w-4 opacity-100" : "w-1.5 opacity-50"}`} />
          ))}
        </span>
      </div>
    </>
  );
};
